module.exports = __webpack_public_path__ + "img/img124.ef0f5cb7.svg";